// src/api/strapi.js
import axios from 'axios';

const strapiApi = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_REST,
});

export default strapiApi;
